import RemoteCall from "../../util/RemoteCall";
let remoteCall = new RemoteCall("/api/noAuth/underlay");

const bindByMobileAsync = (params) => {
    return remoteCall.invoke("bindByMobile", params);
};


export default {
    bindByMobileAsync
}
